export const ALIGN = [
  'left',
  'center',
  'right'
]
